// TaglineSection.jsx
import React from 'react';
import './TaglineSection.css';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations';

function TaglineSection() {
  const { language } = useLanguage();

  return (
    <section className="tagline-section">
      <div className="home-rail">
        <p className="main-description">
          {t('home.tagline1', language)}
        </p>
        <p className="main-description">
          {t('home.tagline2', language)}
        </p>
      </div>
    </section>
  );
}

export default TaglineSection;
